import { z } from "zod";

const configSchema = z.object({
  VERSION: z.string().default("2.0.0"),
});

export const config = configSchema.parse(import.meta.env);
